"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  data: function data() {
    return {
      timeList: [{
        startTime: '',
        endTime: ''
      }]
    };
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.timeList = val !== null && val !== void 0 && val.length ? val : [{
          startTime: '',
          endTime: ''
        }];
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    throttle: _throttle.default,
    changeVal: function changeVal() {
      this.$emit("input", this.timeList);
    },
    removeTime: function removeTime(i) {
      var _this$timeList;
      (_this$timeList = this.timeList) === null || _this$timeList === void 0 ? void 0 : _this$timeList.splice(i, 1);
    },
    addTime: function addTime() {
      var _this$timeList2;
      (_this$timeList2 = this.timeList) === null || _this$timeList2 === void 0 ? void 0 : _this$timeList2.push({
        startTime: '',
        endTime: ''
      });
    }
  }
};